module.exports = __webpack_public_path__ + "img/位图备份.2408da54.png";